import { EPaymentProvider } from '../../../../../shared/PaymentWidgetMicrofrontend';

export enum ECheckType {
  Balance = 'Balance',
  Package = 'Package',
}

export interface ICheckPaymentStatusHandlerParams {
  paymentId: string | undefined;
  type: ECheckType;
  provider: EPaymentProvider;
}
